module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Regular.28e3b551.woff2";